"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Iterates to a deep array in order to map each value of that deeper array.
 *
 * @param {object} object - Object with deeply nested arrays.
 * @param {string} path - "." delimited string path to navigate to inner array.
 * @param {Function} fn - Function to run when mapping over inner array.
 */
var _flatMapDeep = function flatMapDeep() {
  var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var fn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _fp.identity;
  var _split = (0, _fp.split)('.', path),
    _split2 = _toArray(_split),
    first = _split2[0],
    rest = _split2.slice(1);
  var mapped = (0, _fp.flatMap)(function (value) {
    return (0, _fp.isEmpty)(rest) ? fn(value) : _flatMapDeep(value, (0, _fp.join)('.', rest), fn);
  }, object === null || object === void 0 ? void 0 : object[first]);
  return (0, _fp.compact)(mapped);
};
var _default = exports["default"] = _flatMapDeep;
module.exports = exports.default;